(function () {
    const scrollToTopLink = document.getElementById('scrollToTopLink');
    if (!scrollToTopLink) return;
    window.addEventListener('scroll', () => {
        if (document.documentElement.scrollTop > 20) {
            scrollToTopLink.style.display = 'block';
        } else {
            scrollToTopLink.style.display = 'none';
        }
    });
    scrollToTopLink.addEventListener('click', e => {
        e.preventDefault();
        window.scrollTo(0, 0);
    });
})();
